/**
 * Created by r4zi4l on 29.01.2021
 */

const InstantWorker = function (unit, options) { 
    UnitComponent.call(this, unit);

    this.limit = options.limit || cleverapps.parseInterval(InstantWorker.LIMIT);

    this.onDragStart = function () {};
    this.onDragEnd = function () {};

    this.onDestructor = function () {};
};

InstantWorker.prototype = Object.create(UnitComponent.prototype);
InstantWorker.prototype.constructor = InstantWorker;

InstantWorker.prototype.onInfoOpened = function () {
    this.onUpdateState();
};

InstantWorker.prototype.onInfoClosed = function () {
    this.onUpdateState();
};

InstantWorker.prototype.onStartMagic = function () {
    if (this.view) {
        this.view.startMagic();
    }
};

InstantWorker.prototype.onFinishMagic = function () {
    if (this.view) {
        this.view.finishMagic();
    }
};

InstantWorker.prototype.onUpdateState = function () {
    if (this.view) {
        this.view.restoreState(true);
    }
};

InstantWorker.prototype.isMovable = function () {
    return !this.isWorking();
};

InstantWorker.prototype.isFresh = function () {
    return this.limit === cleverapps.parseInterval(InstantWorker.LIMIT);
};

InstantWorker.prototype.isWorking = function () {
    return Boolean(this.assignment);
};

InstantWorker.prototype.save = function (data) {
    data.limit = this.limit;
};

InstantWorker.prototype.destructor = function () {
    Map2d.currentMap.workers.removeInstant(this);

    this.onDestructor();
};

InstantWorker.prototype.getActionInfo = function () {
    return {
        title: this.unit,
        duration: this.limit,
        remains: {
            value: this.limit,
            total: cleverapps.parseInterval(InstantWorker.LIMIT)
        },
        windowParameters: {
            unit: this.unit,
            guideOptions: InstantWorkerGuideOptions
        }
    };
};

InstantWorker.prototype.getPercentage = function () {
    return this.limit * 100 / cleverapps.parseInterval(InstantWorker.LIMIT);
};

InstantWorker.prototype.buildInstantly = function (buildable) {
    const instantWorker = Map2d.currentMap.workers.findInstantAssigned(buildable);
    if (instantWorker || this.assignment) {
        return;
    }

    Map2d.currentMap.showLayerTile(Map2d.LAYER_UNITS, this.unit.x, this.unit.y);

    this.unit.move(this.unit.x, this.unit.y);

    const worker = Map2d.currentMap.workers.findAssigned(buildable.unit);
    if (worker) {
        worker.completeAssignment();
    }

    this.assignment = buildable;
    this.startBuildTime = Date.now();

    this.onStartMagic();
    buildable.startInstantWorker(this);

    if (!worker) {
        const data = { affected: buildable.unit };
        Map2d.mapEvent(Map2d.START_BUILDING, data);
        cleverapps.tutorial.trigger(Map2d.START_BUILDING, data);
    }

    this.doMagicTimeout = Map2dLocation.currentLocation.counter.setTimeout(this.doMagic.bind(this), InstantWorkerView.getBuildAnimationTime(this));
};

InstantWorker.prototype.clearDoMagicTimeout = function () {
    if (this.doMagicTimeout !== undefined) {
        clearTimeout(this.doMagicTimeout);
        this.doMagicTimeout = undefined;
    }
};

InstantWorker.prototype.doMagic = function () {
    const buildable = this.assignment;

    this.clearDoMagicTimeout();

    delete this.assignment;
    delete this.startBuildTime;

    const timeSpend = Math.min(this.limit, buildable.time);

    if (this.limit - timeSpend <= 0) {
        const closestEmptyCell = Map2d.currentMap.findEmptySlot(buildable.unit.x, buildable.unit.y);
        if (closestEmptyCell && (cc.getDistanceChebyshev(buildable.unit, this.unit) > cc.getDistanceChebyshev(buildable.unit, closestEmptyCell))) {
            this.unit.move(closestEmptyCell.x, closestEmptyCell.y);
        }
    }

    this.onFinishMagic(buildable);

    buildable.finishInstantWorker(this);

    if (buildable.time > timeSpend) {
        buildable.unit.suspendBuilding(timeSpend);

        cleverapps.eventBus.trigger("taskEvent", "USE_WORKER");
    } else {
        buildable.unit.completeBuilding();
    }

    this.limit -= timeSpend;
    this.unit.save();

    if (this.limit <= 0) {
        cleverapps.eventBus.trigger("taskEvent", "USE_UP_INSTANT_WORKER");

        Map2dLocation.currentLocation.replace(this.unit, {
            code: this.unit.code,
            stage: 0
        });
    }
};

InstantWorker.prototype.getFullJobTime = function () {
    if (!this.isWorking()) {
        return;
    }
    return cleverapps.parseInterval(this.assignment.unit.getData().buildable);
};

InstantWorker.LIMIT = "1 hour";

if (typeof cc === "undefined") {
    module.exports = InstantWorker;
}
